import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import cx from 'classnames';

import Button from 'base/components/Button';
import TextField from './TextField';
import Select from './Select';
import RadioGroup from './RadioGroup';

import { shirtSizes, departments, allDepartments, transportHours } from 'modules/User/const';

class EntryForm extends Component {
    render() {
    const { department, handleSubmit, isSubmitting, hidden, readOnly } = this.props;
    const formStyles = cx('entryform-form', {
      'entryform--hidden': hidden
    });

    return (
        <form
          className={formStyles}
          onSubmit={handleSubmit}
        >
            <Field
              label="Numer indeksu"
              eng="Index"
              name="index"
              component={TextField}
              pattern="[0-9]{6}"
              title="Indeks w formacie 000000"
              required
              readOnly={readOnly}
            />

            <Field
              label="Imię"
              eng="Name"
              name="name"
              component={TextField}
              required
              readOnly={readOnly}
            />

            <Field
              label="Nazwisko"
              eng="Surname"
              name="surname"
              component={TextField}
              required
              readOnly={readOnly}
            />

            <Field
              label="E-mail"
              eng="E-mail"
              name="mail"
              type="email"
              component={TextField}
              required
              readOnly={readOnly}
            />

            <Field
              label="Numer telefonu"
              eng="Phone number"
              name="phoneNumber"
              type="tel"
              component={TextField}
              pattern="[0-9]{9}"
              title="Numer telefonu w formacie 000000000"
              required
              readOnly={readOnly}
            />

            <Field
              label="Wydział"
              eng="Department"
              name="department"
              options={departments}
              component={Select}
              required
              readOnly={readOnly}
            />

            {
              department === 'w0' &&
              <Field
                label="Wybierz swój wydział"
                eng="Choose your department"
                name="otherDepartment"
                options={allDepartments}
                component={Select}
                required
                readOnly={readOnly}
              />
            }

            <Field
              label="Płeć"
              eng="Sex"
              name="sex"
              options={[{
                label: 'Kobieta',
                value: 'k',
                name: 'sex'
              },
              {
                label: 'Mężczyzna',
                value: 'm',
                name: 'sex'
              }
              ]}
              component={RadioGroup}
              required
              readOnly={readOnly}
            />

            {/* <Field
              label="Rodzaj diety"
              name="diet"
              options={[{
                label: 'Mięsna',
                value: 'meat',
                name: 'diet'
              },
              {
                label: 'Wegeteriańska',
                value: 'vege',
                name: 'diet'
              }
              ]}
              component={RadioGroup}
              required
            /> */}

            <Field
              label="Rozmiar koszulki"
              eng="T-shirt size"
              name="shirtSize"
              options={shirtSizes}
              component={Select}
              required
              readOnly={readOnly}
            />

            <Field
              label="Preferowana godzina wyjazdu"
              eng="Preferred departure time"
              name="transportHour"
              options={transportHours}
              component={Select}
              required
              readOnly={readOnly}
            />

            <Field
              label="Numer telefonu do kontaktu ICE"
              eng="ICE phone number"
              additionalLabel="nr w razie wypadku np. nr rodzica"
              name="iceNumber"
              component={TextField}
              pattern="[0-9]{9}"
              title="Numer telefonu w formacie 000000000"
              required
              readOnly={readOnly}
            />

            <Field
              label="ICE imię i nazwisko"
              eng="ICE name and surname"
              name="icePerson"
              component={TextField}
              readOnly={readOnly}
            />

            <p className="terms">
              Zapoznaj się z{' '}
              <a className="acid-link" href="https://drive.google.com/file/d/1b7MXvWGWRGxDetaAR4VZFn-U0AcBj6k5/view" target="_blank">regulaminem rajdu</a>
            </p>

            {
                !readOnly &&
                <Button disable={isSubmitting} acid>Wyślij</Button>
            }
        </form>
    );
  }
};

let Form = reduxForm({
  form: 'entry'
})(EntryForm);

const selector = formValueSelector('entry') // <-- same as form name
Form = connect(
  state => {
    // can select values individually
    // const hasEmailValue = selector(state, 'hasEmail')
    const department = selector(state, 'department')
    // or together as a group
    return {
      department
    }
  }
)(Form)

export default Form



// WEBPACK FOOTER //
// ./src/modules/User/components/EntryForm.js